import type { ProgramSuggestion } from 'bundles/clips/components/short-form-content/SFCVLPSharedTypes';

type ProgramHomeMiniXdpLinkParameters = {
  courseId?: string;
  courseSlug?: string;
  orgSlug?: string;
  programSlug?: string;
  accessProvidedViaProgram?: ProgramSuggestion;
  trackingName?: string;
  itemId?: string;
  isOrgScoped?: boolean;
};

export const getProgramHomeMiniXdpLink = ({
  courseId,
  courseSlug,
  orgSlug,
  programSlug,
  accessProvidedViaProgram,
  trackingName,
  itemId,
  isOrgScoped,
}: ProgramHomeMiniXdpLinkParameters) => {
  if (!courseId) {
    return '';
  }

  // Org-scoped: link directly to the consumer XDP route.
  // TODO: Update to /organizations/${orgSlug}/learn/${courseSlug} when MERCH-2909 lands.
  if (isOrgScoped && courseSlug) {
    let link = `/learn/${courseSlug}`;
    const params: Record<string, string> = {};
    if (trackingName && itemId) {
      params.fromClip = encodeURIComponent(trackingName + '~' + itemId);
    }
    const qs = new URLSearchParams(params).toString();
    if (qs) {
      link += `?${qs}`;
    }
    return link;
  }

  // Program-scoped: open mini modal on program home
  let programHomeMiniXdpLink;
  if (orgSlug) {
    programHomeMiniXdpLink = `/programs/all/${orgSlug}`;
  } else if (programSlug) {
    programHomeMiniXdpLink = `/programs/${programSlug}`;
  } else if (accessProvidedViaProgram?.slug) {
    programHomeMiniXdpLink = `/programs/${accessProvidedViaProgram.slug}`;
  } else {
    programHomeMiniXdpLink = '';
  }
  const params: Record<string, string> = { productId: courseId, productType: 'course', showMiniModal: 'true' };
  if (trackingName && itemId) {
    params.fromClip = encodeURIComponent(trackingName + '~' + itemId);
  }
  const qs = new URLSearchParams(params).toString();
  if (qs) {
    programHomeMiniXdpLink += `?${qs}`;
  }
  return programHomeMiniXdpLink;
};

export const getClipsTrackingInfo = (fromClip?: string) => {
  const clipsTrackingInfo: Record<string, string> = {};
  if (fromClip) {
    const trackingInfo = fromClip.split('~');
    if (trackingInfo.length === 2) {
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      clipsTrackingInfo.fromClip = trackingInfo[0];
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      clipsTrackingInfo.itemId = trackingInfo[1];
    }
  }
  return clipsTrackingInfo;
};
